/**
 * Created by Ning Jiang on 10/26/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {MonkeysGoldParticleConfigs} from "../../particles/MonkeysGoldParticleConfigs";

require("pixi-particles");

export class MonkeysGoldBigWinCoinsRain extends BaseView {

    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [750, 1150];

    private readonly _coinsConfigs:any[] = [
        MonkeysGoldParticleConfigs.bigWinCoinRain
    ];

    private _coinsEmitters:Emitter[];
    private _container:PIXI.Container;
    private _emitterLayers:PIXI.Container[];

    private _isPlaying:boolean = false;

    constructor(container:PIXI.Container) {
        super();
        this._container = container;
        this._emitterLayers = [];
    }

    protected initAnimations():void {
        this._coinsEmitters = [];
        this._coinsConfigs.forEach((config:any, level:number) => {
            const emitterContainer:PIXI.Container = new PIXI.Container();
            this._container.addChild(emitterContainer);
            const emitter:Emitter = new Emitter(emitterContainer, [{
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : GameResources.getTextures(`bigWinRain${level}`)
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });
    }

    public startRain(playLevel:number):void {
        if(this._isPlaying == false) {
            this._isPlaying = true;
        }

        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._coinsEmitters.forEach((emitter:Emitter, level:number) => {
            if(level <= playLevel) {
                emitter.emit = true;
            }
        });
    }

    public setParticleAmount(particleLevel:number):void {
        this._coinsEmitters.forEach((emitter:Emitter, level:number) => {
            if(particleLevel == 1) {
                emitter.maxParticles = 250;
                emitter.frequency = 0.04;
            } else if(particleLevel == 2) {
                emitter.maxParticles = 500;
                emitter.frequency = 0.02;
            } else {
                emitter.maxParticles = 1000;
                emitter.frequency = 0.01;
            }
        });
    }

    public stopRain():void {
        this._isPlaying = false;
        this._coinsEmitters.forEach((emitter:Emitter) => {
            emitter.emit = false;
        })
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;

        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;

        let screenHeight = Math.max(this._screenHeightRange[0], Math.min(resizeData.height, this._screenHeightRange[1]));
        const startSpeed:number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        const y:number = (0 - ((resizeData.height - 720) / 2));
        const x:number = (0 - ((resizeData.width - 720) / 2));
        this._coinsEmitters.forEach((emitter:Emitter, level:number) => {
            const levelSpeed:number = startSpeed * (1 + 0.05 * level);
            emitter.cleanup();
            emitter.startSpeed.value = levelSpeed;
            emitter.spawnPos.y = y;
            emitter.spawnPos.x = x;
            emitter.spawnRect.width = resizeData.width;
        });
    }
}